export default __webpack_public_path__ + "static/media/maranoa_regional_council.afcbd8b6.png";